<template>
  <FeatureConfig />
  <StagingFrame edit-mode mode="developer" :collapsable-right="false">
    <template #toolbar>
      <CreateToolbar />
    </template>
    <template #canvas>
      <iColumn
        :style-overrides="{
          paddingLeft: 'standard',
          paddingRight: 'standard',
          paddingBottom: 'standard',
          paddingTop: 'standard',
        }"
      >
        <PublicationDetails
          v-if="activeSection === 'publications'"
          :active-publication-id="activePublicationId"
        />
        <AppDetails
          v-if="activeSection === 'apps'"
          :active-app-id="activeAppId"
        />
      </iColumn>
    </template>
    <template #left-panel-one>
      <CreateLeftPanelOne
        :active-section="activeSection"
        @select:section="activeSection = $event"
      />
    </template>
    <template #left-panel-two>
      <CreateLeftPanelTwo
        :active-section="activeSection"
        :currently-selected-app-id="activeAppId"
        :currently-selected-publication-id="activePublicationId"
        @select:publication="activePublicationId = $event.publication_id"
        @select:app="activeAppId = $event.dynamic_app_id"
      />
    </template>
  </StagingFrame>
</template>

<script>
import StagingFrame from "~/components/staging-frame/StagingFrame.vue";
import CreateToolbar from "@/components/create-dashboard/CreateToolbar.vue";
import CreateLeftPanelOne from "@/components/create-dashboard/CreateLeftPanelOne.vue";
import CreateLeftPanelTwo from "@/components/create-dashboard/CreateLeftPanelTwo.vue";
import PublicationDetails from "@/components/create-dashboard/views/PublicationDetails.vue";
import FeatureConfig from "%/components/FeatureConfig.vue";
import AppDetails from "@/components/create-dashboard/views/AppDetails.vue";

export default {
  name: "CreateDashboard",
  components: {
    AppDetails,
    FeatureConfig,
    PublicationDetails,
    CreateToolbar,
    CreateLeftPanelOne,
    CreateLeftPanelTwo,
    StagingFrame,
  },
  data() {
    return {
      activePublicationId: null,
      activeAppId: null,
      activeSection: "publications",
    };
  },
};
</script>

<style lang="scss" scoped>

</style>
